import React from 'react';

import { IconSize, SvgIcon } from './SvgIcon';

interface IconProps {
  size?: IconSize;
}

const PaymentMasterCard = (props: IconProps): JSX.Element => (
  <SvgIcon size={props?.size}>
    <rect
      x=".75"
      y="3.75"
      width="22.5"
      height="16.5"
      rx="1.25"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 16h5V8H9v8z"
      fill="#FF5F00"
    />
    <mask id="a" maskUnits="userSpaceOnUse" x="4" y="6" width="8" height="11">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 6.802h8V17H4V6.802z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.111 11.9A5.147 5.147 0 0112 7.893c-2.146-1.74-5.254-1.355-6.942.858-1.687 2.214-1.315 5.42.832 7.16a4.827 4.827 0 006.11 0 5.152 5.152 0 01-1.888-4.01z"
        fill="#EB001B"
      />
    </g>
    <mask id="b" maskUnits="userSpaceOnUse" x="12" y="6" width="9" height="11">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.8h8V17h-8V6.8z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#b)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 11.9c0 2.817-2.214 5.1-4.944 5.1A4.845 4.845 0 0112 15.908c2.147-1.741 2.52-4.946.832-7.16A5.04 5.04 0 0012 7.891c2.147-1.74 5.255-1.357 6.943.857A5.196 5.196 0 0120 11.899v.002z"
        fill="#F79E1B"
      />
    </g>
  </SvgIcon>
);

export default PaymentMasterCard;
